import { registerRootComponent } from "expo";
import App from "./App";
import { initializeI18n } from "./src/locales/translate";

// registerRootComponent calls AppRegistry.registerComponent('main', () => App);
// It also ensures that whether you load the app in Expo Go or in a native build,
// the environment is set up appropriately

initializeI18n(registerRootComponent(App));
